export default __webpack_public_path__ + "static/media/PTC.36e37edc.png";